export default {
  apps: [],
  foundUsers: [],
  user: null,
  accessToken: '',
  isSendRefreshToken: false,
};



// WEBPACK FOOTER //
// ./src/store/state.js